function toggleEnquire() {
  var modal = document.getElementById("enquireModal");
  var mask = document.getElementById('enquireMask');

  // Toggle the .open class on the modal
  modal.classList.toggle("open");

  // Check if the modal has the .open class and set CSS properties accordingly
  if (modal.classList.contains("open")) {
    mask.style.opacity = '1';
    mask.style.display = 'block';
  } else {
    mask.style.opacity = '0';
    mask.style.display = 'none';
  }
}

function toggleSample() {
  var modal = document.getElementById("sampleModal");
  var mask = document.getElementById('sampleMask');

  // Toggle the .open class on the modal
  modal.classList.toggle("open");

  // Check if the modal has the .open class and set CSS properties accordingly
  if (modal.classList.contains("open")) {
    mask.style.opacity = '1';
    mask.style.display = 'block';
  } else {
    mask.style.opacity = '0';
    mask.style.display = 'none';
  }
}